export * from './doctor-slots/modal-doctor-slots.component';
export * from './share-attendance-resume/modal-share-attendance-resume.component';
export * from './share-attendance-resume/modal-share-attendance-resume.module';
export * from './scheduled-successfully/modal-scheduled-successfully.component';
export * from './doctor-card-slots/modal-doctor-card-slots.component';
export * from './doctor-card-slots/modal-doctor-card-slots.module';
export * from './onboard/modal-onboard.module';
export * from './onboard/modal-onboard.component';
